import { useMemo } from "react"
import { useTheme } from "@mui/material/styles"
import {
  ATTRIBUTION_COLORS,
  COLORS,
} from "helpers/analyzeConstants"

const DEFAULT_CHART = {
  total: ATTRIBUTION_COLORS.TOTAL,
  factor: ATTRIBUTION_COLORS.FACTOR,
  alpha: ATTRIBUTION_COLORS.ALPHA,
  trading: ATTRIBUTION_COLORS.TRADING,
  riskFree: ATTRIBUTION_COLORS.RISK_FREE,
  series: COLORS,
}

function getChartPalette(theme) {
  const chart = theme?.palette?.chart
  if (!chart) return null
  return {
    total: chart.total ?? DEFAULT_CHART.total,
    factor: chart.factor ?? DEFAULT_CHART.factor,
    alpha: chart.alpha ?? DEFAULT_CHART.alpha,
    trading: chart.trading ?? DEFAULT_CHART.trading,
    riskFree: chart.riskFree ?? DEFAULT_CHART.riskFree,
    series: Array.isArray(chart.series) && chart.series.length ? chart.series : DEFAULT_CHART.series,
  }
}

export function useThemeChartColors() {
  const theme = useTheme()
  return useMemo(() => getChartPalette(theme) ?? DEFAULT_CHART, [theme])
}

export function applyChartColorsToItems(items, chartColors) {
  if (!chartColors || !items) return items
  const colorById = {
    total: chartColors.total,
    factor: chartColors.factor,
    alpha: chartColors.alpha,
    tradingPnl: chartColors.trading,
    residual: chartColors.riskFree,
    factor_total: chartColors.factor,
  }
  return items.map((item) => ({
    ...item,
    color: colorById[item.id] ?? item.color,
  }))
}

const RISK_COLOR_BY_ID = {
  total: "total",
  factor: "factor",
  specific: "alpha",
  factor_total: "factor",
}

export function applyRiskChartColorsToItems(items, chartColors) {
  if (!chartColors || !items) return items
  return items.map((item) => {
    const key = RISK_COLOR_BY_ID[item.id]
    const color = key ? chartColors[key] : item.color
    return color ? { ...item, color } : item
  })
}
